import { render, staticRenderFns } from "./RatingOrderModal.vue?vue&type=template&id=4f294040&scoped=true"
import script from "./RatingOrderModal.vue?vue&type=script&lang=ts"
export * from "./RatingOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./RatingOrderModal.vue?vue&type=style&index=0&id=4f294040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f294040",
  null
  
)

export default component.exports